import { useState } from "react";
import { Aviso, Cartao } from "../ui";
import { mensagemDoConsole } from "../../nucleo/console";
import { larguraNaGrade, valorLegivel, useDadosDoWidget } from "../../nucleo/paineis";
import type { FiltrosGuardados, WidgetParaVer } from "../../nucleo/paineis";
import { DrillDoNumero } from "./DrillDoNumero";
import { FiltrosDoWidget } from "./FiltrosDoWidget";

/**
 * Um widget do painel: os números dele e, ao clicar em qualquer um, os chamados que o compõem.
 *
 * Os filtros começam no que o painel guardou e a pessoa pode mudá-los aqui, só para esta tela —
 * quem decide o que o painel guarda é o editor.
 */
export function WidgetDoPainel({ widget }: { widget: WidgetParaVer }) {
  const [filtros, setFiltros] = useState<FiltrosGuardados>(widget.filtros);
  const [aberto, setAberto] = useState<string | null>(null);
  const dados = useDadosDoWidget(widget.tipo, filtros);

  function mudarFiltros(proximo: FiltrosGuardados) {
    setFiltros(proximo);
    // O número aberto era do recorte anterior.
    setAberto(null);
  }

  return (
    <Cartao
      titulo={widget.titulo}
      className={larguraNaGrade(widget.colunas)}
      data-testid={`widget-${widget.tipo}`}
    >
      <details className="mb-3">
        <summary className="nota-rodape">Filtros</summary>
        <div className="mt-2">
          <FiltrosDoWidget
            aceitos={widget.filtros_aceitos}
            valor={filtros}
            aoMudar={mudarFiltros}
            periodoPadrao={widget.periodo_padrao}
          />
        </div>
      </details>
      {dados.isPending ? <p role="status">Carregando…</p> : null}
      {dados.isError ? <Aviso tom="erro">{mensagemDoConsole(dados.error)}</Aviso> : null}
      {dados.data ? (
        <>
          {dados.data.aviso ? (
            <Aviso tom="atencao" className="mb-2">
              {dados.data.aviso}
            </Aviso>
          ) : null}
          <ul className="grid gap-2 grid-cols-2 list-none p-0 m-0">
            {dados.data.numeros.map((numero) => (
              <li key={numero.chave}>
                <button
                  type="button"
                  className="botao botao--fantasma w-full text-left"
                  aria-pressed={aberto === numero.chave}
                  aria-label={`${numero.rotulo}: ${valorLegivel(numero)}. Ver os chamados.`}
                  data-testid={`numero-${numero.chave}`}
                  onClick={() => setAberto(aberto === numero.chave ? null : numero.chave)}
                >
                  <span className="block nota-rodape">{numero.rotulo}</span>
                  <span className="block titulo-secao m-0">{valorLegivel(numero)}</span>
                  {numero.detalhe ? <span className="block nota-rodape">{numero.detalhe}</span> : null}
                </button>
              </li>
            ))}
          </ul>
          {aberto ? <DrillDoNumero tipo={widget.tipo} numero={aberto} filtros={filtros} /> : null}
        </>
      ) : null}
    </Cartao>
  );
}
